export const API_PARTICIPANTS_INDEX = 'API_PARTICIPANTS_INDEX'
// Internal per-page request action whose success/failure the index saga awaits
// while paginating. Routed through AUTHED_REQUEST so auth/global error handling
// is reused.
export const API_PARTICIPANTS_PAGE = 'API_PARTICIPANTS_PAGE'
export const API_PARTICIPANTS_UPDATE = 'API_PARTICIPANTS_UPDATE'
export const API_PARTICIPANTS_CREATE = 'API_PARTICIPANTS_CREATE'
export const API_PARTICIPANTS_ARCHIVE = 'API_PARTICIPANTS_ARCHIVE'
export const API_PARTICIPANTS_UNARCHIVE = 'API_PARTICIPANTS_UNARCHIVE'

export type ParticipantUpdate = {
  name?: string;
  participantGroupId?: string;
};

export type ParticipantCreate = {
  name: string;
  participantGroupId: string;
};

// Tags an action creator with the OpenAPI operation id so permission gating
// (Permissions.onlyPermissibleActions) can drop it when the user lacks access.
const createOperation = <A extends (...args: any[]) => { type: string }>(
  actionCreator: A,
  operationId: string,
): A & { operationId: string } => {
  const operation = actionCreator as A & { operationId: string }
  operation.operationId = operationId
  return operation
}

export const fetch = () => ({
  type: API_PARTICIPANTS_INDEX
})

export const updateParticipant = createOperation(
  (id: string, changes: ParticipantUpdate) => ({
    type: API_PARTICIPANTS_UPDATE,
    id,
    changes,
  }),
  API_PARTICIPANTS_UPDATE,
)

export const createParticipant = createOperation(
  (participant: ParticipantCreate) => ({
    type: API_PARTICIPANTS_CREATE,
    participant,
  }),
  API_PARTICIPANTS_CREATE,
)

export const archiveParticipant = createOperation(
  (id: string) => ({
    type: API_PARTICIPANTS_ARCHIVE,
    id,
  }),
  API_PARTICIPANTS_ARCHIVE,
)

export const unarchiveParticipant = createOperation(
  (id: string) => ({
    type: API_PARTICIPANTS_UNARCHIVE,
    id,
  }),
  API_PARTICIPANTS_UNARCHIVE,
)
